module.exports = __webpack_public_path__ + "img/Zhejiang.e6275438.jpg";